import * as constants from "../store/Constants";
import { Recipe } from "../store/Recipe";

interface LocalStorageInterface {
  index: Recipe[];
  url: string;
  date?: Date;
}

export const getLocalStorage = (): LocalStorageInterface => {
  // reads local storage and returns
  // the recipe index
  // the date of when it was last updated
  // the url used to update
  const indexJson = localStorage.getItem(constants.LocalStorageRecipeIndex);
  var index: Recipe[] = [];
  if (indexJson !== null) {
    index = JSON.parse(indexJson);
  }

  const urlJson = localStorage.getItem(constants.LocalStorageUrl);
  var url = "";
  if (urlJson !== null) {
    url = urlJson;
  }

  const dateJson = localStorage.getItem(constants.LocalStorageDate);
  var date = undefined;
  if (dateJson !== null) {
    date = new Date(dateJson);
  }

  return {
    index: index,
    url: url,
    date: date,
  };
};

interface setLocalStorageInterface {
  index: Recipe[];
  url: string;
  date: Date;
}

export const setLocalStorage = (props: setLocalStorageInterface) => {
  localStorage.setItem(
    constants.LocalStorageRecipeIndex,
    JSON.stringify(props.index)
  );
  localStorage.setItem(constants.LocalStorageUrl, props.url);
  localStorage.setItem(constants.LocalStorageDate, props.date.toString());
};
